module.exports = __webpack_public_path__ + "static/media/onlineCourses-white.81be1230.svg";